<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <div class="modal-title" i18n>Connect To VRBO</div>
    <app-page-help [articleId]="'vvj05rs8cw'"
                   videoId="-"></app-page-help>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>

<mat-stepper [linear]="false" #stepper class="m-3" [class.flexiable]="(config$ | async)?.status">
  <mat-step
    i18n-label
    label="Getting Started"
    [editable]="stepper.selectedIndex < 3"
    [state]="stepper.selectedIndex > 0 ? 'done' : 'number'"
  >
    <app-connect-vrbo-wizard-step1 (next)="stepper.selectedIndex = 1"></app-connect-vrbo-wizard-step1>
  </mat-step>
  <mat-step
    i18n-label
    label="Channel Config"
    [editable]="stepper.selectedIndex < 3"
    [state]="stepper.selectedIndex > 1 ? 'done' : 'number'"
  >
    <ng-template matStepContent>
      <app-connect-vrbo-wizard-step2
        (prev)="stepper.previous()"
        (next)="stepper.next()"
        [channel]="channel"
        #step2
      ></app-connect-vrbo-wizard-step2>
    </ng-template>
  </mat-step>
  <mat-step
    i18n-label
    label="Select Rentals"
    [editable]="stepper.selectedIndex < 3"
    [state]="stepper.selectedIndex > 2 ? 'done' : 'number'"
  >
    <app-connect-vrbo-wizard-step3
      (prev)="stepper.previous()"
      (next)="stepper.next()"
      [channel]="channel"
      #step3
    ></app-connect-vrbo-wizard-step3>
  </mat-step>
  <mat-step
    i18n-label
    label="Complete"
    [editable]="stepper.selectedIndex < 3"
    [state]="stepper.selectedIndex > 3 ? 'done' : 'number'"
  >
    <app-connect-vrbo-wizard-complete (done)="close()"></app-connect-vrbo-wizard-complete>
  </mat-step>
  <ng-template matStepperIcon="done">
    <i class="cs-icon cs-icon-check2 text-xs"></i>
  </ng-template>
  <ng-template matStepperIcon="edit">
    <i class="cs-icon cs-icon-check2 text-xs"></i>
  </ng-template>
</mat-stepper>
